import { render } from "./EnduserChatLayout.vue?vue&type=template&id=b99cbd42"
import script from "./EnduserChatLayout.vue?vue&type=script&lang=js"
export * from "./EnduserChatLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__